import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOKS_SEARCH } from '../../constants/booksTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { bookListSchema } from '../../schemas/Normalizr';

export function* searchBooks(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

    const params = action.payload;

  try {
    yield *httpSaga(BOOKS_SEARCH, call(booksAPI.search, params), bookListSchema);
  } catch (e) {
    yield put(error(BOOKS_SEARCH, e));
  } finally {
    yield put(doneIndicator(BOOKS_SEARCH));
  }
}

export function* watchSearchBooks() {
  yield takeEvery(BOOKS_SEARCH, searchBooks);
}

export default function* root() {
  yield all([
    fork(watchSearchBooks)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/booksSearch.js